import React from 'react';

export const CloseModalIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.0013 34.8327C27.7096 34.8327 34.8346 27.7077 34.8346 18.9993C34.8346 10.291 27.7096 3.16602 19.0013 3.16602C10.293 3.16602 3.16797 10.291 3.16797 18.9993C3.16797 27.7077 10.293 34.8327 19.0013 34.8327Z"
      stroke="#142D6F" stroke-opacity="0.2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.5195 23.4812L23.4812 14.5195" stroke="#142D6F" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M23.4812 23.4812L14.5195 14.5195" stroke="#142D6F" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round"/>
  </svg>


);
